<template>
  <v-card>
    <v-card-text>
      <v-switch v-model="showRemarkPlanner" label="Toon opmerking planner"></v-switch>
      <v-combobox v-model="citiesSelected" :items="cities" chips deletable-chips multiple
                  label="Selecteer stad of dorp"></v-combobox>
      <v-flex xs12 sm10 md8 lg10>
        <v-list two-line subheader v-if="!showAddresses">
          <div v-for="item in filterPlanningItems(planningItems)" :key="item.date">
            <v-subheader inset>week {{ item.weekNumber }} - {{ format(item.date) }}</v-subheader>
            <div v-for="visit in item.visits" :key="visit.time">
              <div class="address-left" v-for="address in filterAddresses(visit.addresses)" :key="address.uniqueId" :inactive="!linkActive">
                <v-list-tile @click="load(address.details)">
                  <!-- use inactive to disable @click -->
                  <v-list-tile-content>
                    <v-list-tile-title>{{ visit.time.substr(0, 5) }} - {{ address.area }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ address.address }} {{ address.city }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <display-planner-remark :address="address.details" v-if="showRemarkPlanner"
                                        margin="true"></display-planner-remark>
              </div>
            </div>
            <v-divider inset></v-divider>
          </div>
        </v-list>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.address-left {
  text-align: left;
}
</style>

<script>
import {mapActions} from "vuex";
import {planningService} from "@/services/planner";
import moment from "moment";
import DisplayPlannerRemark from "@/components/DisplayPlannerRemark";

export default {
  name: "actual-planning-list",
  components: {DisplayPlannerRemark},
  props: {
    linkActive: Boolean,
    selectCity: String,
  },
  data: () => ({
    planningItems: [],
    addresses: [],
    cities: [],
    citiesSelected: [],
    showAddresses: false,
    showRemarkPlanner: true,
  }),
  methods: {
    ...mapActions(["loadAddress"]),
    filterPlanningItems(items) {
      return items.filter(e => this.checkIfItemHasAddresses(e));
    },
    filterAddresses(addresses) {
      if (this.citiesSelected.length === 0) {
        return addresses;
      }
      return addresses.filter(e => this.citiesSelected.filter(cs => e.city.toUpperCase().startsWith(cs.toUpperCase())).length > 0);
    },
    checkIfItemHasAddresses(item) {
      return item.visits.flatMap(e => this.filterAddresses(e.addresses)).length > 0;
    },
    loadPlanning() {
      planningService.resolvePlannning().then(
          result => {
            this.planningItems = result.data;//.map(e => {e.city.toUpperCase(); return e;});

            let citySet = new Set();

            this.planningItems.flatMap(e => e.visits)
                .flatMap(e => e.addresses)
                .forEach(e => citySet.add(e.city.toUpperCase()));

            this.cities = [...citySet].sort();
          }
      );

      if (this.selectCity) {
        this.citiesSelected.push(this.selectCity);
      }
    },
    format(date) {
      if (date) {
        let curMoment = moment(date);
        curMoment.locale("nl");
        return curMoment.format("dddd D MMMM YYYY");
      }
      return "onbekend";
    },
    load(address) {
      this.loadAddress(address);
      this.$router.push("/address");
    }
  },
  created() {
    this.loadPlanning();
  }
}
</script>
